"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useDataset = function () {
  let datasets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _react.useMemo)(() => Object.entries(datasets).reduce((prev, _ref) => {
    let [key, value] = _ref;
    prev[key] = String(value);
    return prev;
  }, {}), [datasets]);
};
var _default = exports.default = useDataset;